
export default {
  props: {
    sourceData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      iconList: []
    }
  },
  watch: {
    sourceData: {
      handler(val) {
        this.iconList = val
      },
      immediate: true
    }
  }
}
